/**
 * Table styles shared by ag-grid (config/agGrid/theme) and antd tables (AppConfigProvider, GlobalStyle), so the
 * two table components look alike. Kept apart from the grid theme so importing it does not pull ag-grid into
 * the initial bundle.
 */
export const TABLE_FONT_FAMILY = '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
export const TABLE_FONT_SIZE = 12
/** Default ag-grid row height. antd rows have no fixed height; use size="small" tables to get close to it. */
export const TABLE_ROW_HEIGHT = 24
export const TABLE_HEADER_FONT_FAMILY = '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
export const TABLE_HEADER_FONT_SIZE = 10
export const TABLE_HEADER_FONT_WEIGHT = 550
export const TABLE_HEADER_BACKGROUND = '#F9FAFB'
export const TABLE_HEADER_TEXT_COLOR = '#1f1f1f'
/** Same as colorBorderSecondary in AppConfigProvider, which antd uses for its own bordered tables */
export const TABLE_BORDER_COLOR = '#e5e5e5'
